module.exports = __webpack_public_path__ + "static/img/s1img2.485a879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/s1img2.png
// module id = SE7T
// module chunks = 0